import { REPORTS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
const statisticsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getStatistics: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/extracted-files-statistics`,
            }),
        }),
    }),
    overrideExisting: true,
});
export const { useGetStatisticsQuery } = statisticsApi;
//# sourceMappingURL=statistics.api.js.map